export const getLatestUpdateTime = () => {
  const now = new Date();

  // 한국 시간으로 변환
  const seoulTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Seoul',
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
  }).format(now);

  const [currentHour, currentMinute] = seoulTime.split(':').map(Number);

  // 현재 시각이 매 시각 20분 이후인지 확인
  if (currentMinute >= 20) {
    return `${currentHour}:20`;
  }
  // 매 시각 20분 전인 경우 이전 시간으로 표기
  return `${currentHour - 1 < 0 ? 23 : currentHour - 1}:20`;
};
